export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index'),
    meta: {
      title: '倍明官网 img助手/图片编辑助手 - 简单的在线处理图片工具',
      content: {
        keywords: 'img助手、图片编辑助手、图片编辑、格式转化、拼图、尺寸变换、图片剪裁、图片旋转、图片镜像、添加水印、添加文字'
      }
    }
  },
]



// WEBPACK FOOTER //
// ./src/vue/router/modules/home.js